import { RadioGroup, Stack, VStack } from '@chakra-ui/react'
import { Body, useSyncedState } from '@missionlabs/react'
import { UserCallRoute } from '@missionlabs/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RedirectExternalRadio } from 'shared/components/OutOfHours/RedirectExternalRadio'
import { RedirectInternalRadio } from 'shared/components/OutOfHours/RedirectInternalRadio'
import { RingOutRadio } from 'shared/components/OutOfHours/RingOutRadio'
import { VoicemailNoMessageRadio } from 'shared/components/OutOfHours/VoicemailNoMessageRadio'
import { VoicemailRadio } from 'shared/components/OutOfHours/VoicemailRadio'

type UnansweredCallRadioProp = {
    callRoute: UserCallRoute
    onUpdate: (payload: Partial<UserCallRoute>) => void
    minW?: string
}

export const UnansweredCallRadio: FC<UnansweredCallRadioProp> = ({ callRoute, onUpdate, minW }) => {
    const { t } = useTranslation()

    const [forwardType, setForwardType] = useSyncedState<string>(callRoute?.inHoursUnanswered ?? '')

    return (
        <VStack spacing="16px" align="flex-start" w="100%">
            <RadioGroup value={forwardType} onChange={setForwardType} alignSelf="start">
                <Body size="sm" variant="bold" py="12px">
                    {t('calls.unanswered')}
                </Body>
                <Stack spacing={1}>
                    <RingOutRadio onUpdate={onUpdate} />
                    <VoicemailRadio
                        type="inHoursUnanswered"
                        forwardType={forwardType}
                        callRoute={callRoute}
                        onUpdate={onUpdate}
                        minW={minW}
                    />
                    <VoicemailNoMessageRadio
                        type="inHoursUnanswered"
                        forwardType={forwardType}
                        callRoute={callRoute}
                        onUpdate={onUpdate}
                        minW={minW}
                    />
                    <RedirectInternalRadio
                        type="inHoursUnanswered"
                        forwardType={forwardType}
                        callRoute={callRoute}
                        onUpdate={onUpdate}
                        minW={minW}
                    />
                    <RedirectExternalRadio
                        type="inHoursUnanswered"
                        forwardType={forwardType}
                        callRoute={callRoute}
                        onUpdate={onUpdate}
                        minW={minW}
                    />
                </Stack>
            </RadioGroup>
        </VStack>
    )
}
